<template>
  <section>
    <p class="pt-1 text-grey-text-subdued">Step 1 of 2</p>
    <h2 class="pt-16 heading-1">Introduce yourself</h2>
    <p class="text-small my-8 text-grey-text-subdued">
      Help families get to know you better by sharing your {{ careType }} experience.
    </p>
  </section>
</template>

<script lang="ts">
export default {
  name: 'CareTypeFormHeader',
  props: {
    careType: {
      type: String,
      required: true,
    },
  },
};
</script>
